// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dpu-map-dropdown-container {
  background-color: var(--background-color-4);
}

.dpu-dropdown-map-cesium {
  width: 100%;
}

.dpu-dropbtn-map-cesium {
  position: relative;
  display: flex;
  width: 100%;
  height: 75px;
  padding: 0;
  background-color: transparent;
  border: 1px solid transparent;
  overflow: hidden; /* Giúp ảnh không tràn ra ngoài */
  cursor: pointer;
  align-items: center;
}

.dpu-dropbtn-map-cesium:hover {
  border: 1px solid var(--accent-fill-hover);
}

.dropbtn-text-map-cesium,
.name-map {
  color: var(--color-text-1);
  width: 100%;
  height: 100%;

  line-height: 75px;
  text-align: left;
  padding-left: 5px;
}

.dpu-dropbtn-map-cesium img {
  width: 75px; /* Đặt chiều rộng bằng 100% */
  height: 100%; /* Đặt chiều cao bằng 100% */
  object-fit: cover; /* Ảnh sẽ bao phủ toàn bộ mà không bị méo */
  background-color: #fff;
  flex-shrink: 0;
}
.dropbtn-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.dropbtn-icon svg {
  fill: var(--color-icon-1);
}
.dpu-dropdown-content-map-cesium {
  display: none;
  position: absolute;
  left: 0;
  border-radius: 0 0 4px 4px;
  padding: 5px;
  top: 111px;
  background-color: var(--background-color-4);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 5;
  width: 100%;
  max-height: 300px;
  overflow: auto;
}

.dpu-dropdown-content-map-cesium .dpu-dropdown-content-child-container {
  text-decoration: none;
  display: flex;
}

.dpu-dropdown-content-child-container {
  cursor: pointer;
  width: 100%;
  border: 1px solid transparent;
  height: 75px;
  overflow: hidden;
  margin-bottom: 5px;
  /* margin-bottom: 5px; */
}

/* .dropdown-content-child-container:hover .container-img,
.dropdown-content-child-container.active .container-img {
  height: 75px;
} */

/* .dropdown-content-child-container:hover .container-img img,
.dropdown-content-child-container.active .container-img img {
  width: 75px;
  height: 75px;
} */
.dpu-dropdown-content-child-container:hover,
.dpu-dropdown-content-child-container.active {
  border: 1px solid var(--accent-base-color);
}

.dpu-dropdown-content-child-container:hover div,
.dpu-dropdown-content-child-container.active div {
  color: var(--accent-base-color);
}

.container-img {
  height: 100%;
  width: 75px;
  background-color: #fff;
  flex-shrink: 0;
}

.dpu-dropdown-content-child-container img {
  object-fit: cover;
  width: 75px;
  height: 75px;
}
.dpu-dropdown-map-cesium.active .dpu-dropdown-content-map-cesium {
  display: block;
}
.dpu-dropdown-map-cesium .dropbtn-icon {
  transform-origin: center calc(50% - 3px); /* Đặt tâm xoay cao lên 3px */
  transition: 0.2s;
}
.dpu-dropdown-map-cesium.active .dropbtn-icon {
  transform: rotate(180deg);
}
/* 
.dpu-dropdown-map-cesium:hover .dropdown-content-map-cesium {
  display: block;
} */
`, "",{"version":3,"sources":["webpack://./src/styles/mapWeather.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB,EAAE,iCAAiC;EACnD,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,YAAY;;EAEZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW,EAAE,6BAA6B;EAC1C,YAAY,EAAE,4BAA4B;EAC1C,iBAAiB,EAAE,2CAA2C;EAC9D,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,0BAA0B;EAC1B,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,+CAA+C;EAC/C,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;;GAGG;;AAEH;;;;GAIG;AACH;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,wCAAwC,EAAE,6BAA6B;EACvE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;;;GAGG","sourcesContent":[".dpu-map-dropdown-container {\r\n  background-color: var(--background-color-4);\r\n}\r\n\r\n.dpu-dropdown-map-cesium {\r\n  width: 100%;\r\n}\r\n\r\n.dpu-dropbtn-map-cesium {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 75px;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  border: 1px solid transparent;\r\n  overflow: hidden; /* Giúp ảnh không tràn ra ngoài */\r\n  cursor: pointer;\r\n  align-items: center;\r\n}\r\n\r\n.dpu-dropbtn-map-cesium:hover {\r\n  border: 1px solid var(--accent-fill-hover);\r\n}\r\n\r\n.dropbtn-text-map-cesium,\r\n.name-map {\r\n  color: var(--color-text-1);\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  line-height: 75px;\r\n  text-align: left;\r\n  padding-left: 5px;\r\n}\r\n\r\n.dpu-dropbtn-map-cesium img {\r\n  width: 75px; /* Đặt chiều rộng bằng 100% */\r\n  height: 100%; /* Đặt chiều cao bằng 100% */\r\n  object-fit: cover; /* Ảnh sẽ bao phủ toàn bộ mà không bị méo */\r\n  background-color: #fff;\r\n  flex-shrink: 0;\r\n}\r\n.dropbtn-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-right: 5px;\r\n}\r\n.dropbtn-icon svg {\r\n  fill: var(--color-icon-1);\r\n}\r\n.dpu-dropdown-content-map-cesium {\r\n  display: none;\r\n  position: absolute;\r\n  left: 0;\r\n  border-radius: 0 0 4px 4px;\r\n  padding: 5px;\r\n  top: 111px;\r\n  background-color: var(--background-color-4);\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n  z-index: 5;\r\n  width: 100%;\r\n  max-height: 300px;\r\n  overflow: auto;\r\n}\r\n\r\n.dpu-dropdown-content-map-cesium .dpu-dropdown-content-child-container {\r\n  text-decoration: none;\r\n  display: flex;\r\n}\r\n\r\n.dpu-dropdown-content-child-container {\r\n  cursor: pointer;\r\n  width: 100%;\r\n  border: 1px solid transparent;\r\n  height: 75px;\r\n  overflow: hidden;\r\n  margin-bottom: 5px;\r\n  /* margin-bottom: 5px; */\r\n}\r\n\r\n/* .dropdown-content-child-container:hover .container-img,\r\n.dropdown-content-child-container.active .container-img {\r\n  height: 75px;\r\n} */\r\n\r\n/* .dropdown-content-child-container:hover .container-img img,\r\n.dropdown-content-child-container.active .container-img img {\r\n  width: 75px;\r\n  height: 75px;\r\n} */\r\n.dpu-dropdown-content-child-container:hover,\r\n.dpu-dropdown-content-child-container.active {\r\n  border: 1px solid var(--accent-base-color);\r\n}\r\n\r\n.dpu-dropdown-content-child-container:hover div,\r\n.dpu-dropdown-content-child-container.active div {\r\n  color: var(--accent-base-color);\r\n}\r\n\r\n.container-img {\r\n  height: 100%;\r\n  width: 75px;\r\n  background-color: #fff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dpu-dropdown-content-child-container img {\r\n  object-fit: cover;\r\n  width: 75px;\r\n  height: 75px;\r\n}\r\n.dpu-dropdown-map-cesium.active .dpu-dropdown-content-map-cesium {\r\n  display: block;\r\n}\r\n.dpu-dropdown-map-cesium .dropbtn-icon {\r\n  transform-origin: center calc(50% - 3px); /* Đặt tâm xoay cao lên 3px */\r\n  transition: 0.2s;\r\n}\r\n.dpu-dropdown-map-cesium.active .dropbtn-icon {\r\n  transform: rotate(180deg);\r\n}\r\n/* \r\n.dpu-dropdown-map-cesium:hover .dropdown-content-map-cesium {\r\n  display: block;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
